/**
 * Users OpenAPI Specification
 *
 * Generates OpenAPI 3.0 spec for users endpoints with /works-lite/users base path.
 */

import { generateOpenApi } from '@ts-rest/open-api';
import { usersContract } from './users.contract.js';

export const usersOpenApiSpec = generateOpenApi(
  usersContract,
  {
    info: {
      title: 'Skewb Works Users API',
      version: '1.0.0',
      description:
        'Type-safe users API for Skewb Works Lite. All endpoints use Zod validation and return typed responses.',
      contact: {
        name: 'Skewb Works Development Team',
      },
    },
    servers: [
      {
        url: 'https://localhost:8080',
        description: 'Local development server',
      },
    ],
    pathPrefix: '/works-lite/users',
    tags: [
      {
        name: 'Users',
        description: 'User management endpoints',
      },
    ],
  },
  {
    setOperationId: true,
    operationMapper: (operation) => ({
      ...operation,
      tags: ['Users'],
    }),
  },
);
